/** Must match server `ADMIN_ACTION_KEYS`. */
export const ADMIN_ACTION_KEYS = [
  'updateInvestmentOrderStatus',
  'updateOrderWithdrawalStatus',
  'updateInvestmentLimit',
  'blockInvestor',
  'resendVerificationLink',
  'addInvestorOpportunityTerms',
  'manualShareSale',
] as const

export type AdminActionKey = typeof ADMIN_ACTION_KEYS[number]

const all = (v: boolean): Record<AdminActionKey, boolean> => {
  const o = {} as Record<AdminActionKey, boolean>
  for (const k of ADMIN_ACTION_KEYS) {
    o[k] = v
  }
  return o
}

export const getDefaultActionGrantsForRole = (role: string): Record<AdminActionKey, boolean> => {
  if (role === 'CREDIBILA_DEV') {
    return all(false)
  }
  return all(true)
}

export const normalizeActionGrantsFromLogin = (
  role: string,
  raw?: Record<string, unknown> | null,
): Record<AdminActionKey, boolean> => {
  const base = getDefaultActionGrantsForRole(role)
  if (!raw || typeof raw !== 'object') {
    return base
  }
  const next = { ...base }
  for (const k of ADMIN_ACTION_KEYS) {
    const v = raw[k]
    if (v === true || v === false) {
      next[k] = v
    }
  }
  return next
}

/** `false` explicitly denies; missing keys use defaults from role. */
export const isActionAllowed = (
  grants: Record<AdminActionKey, boolean> | undefined,
  key: AdminActionKey,
): boolean => {
  if (!grants) {
    return true
  }
  return grants[key] !== false
}
